import React from "react";
import { Checkbox, SxProps, Theme, Typography, FormControlLabel } from "@mui/material";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import { FieldValues, Control, Controller, Path, RegisterOptions } from "react-hook-form";

interface FormCheckBoxProps<T extends FieldValues> {
  id: string;
  name: Path<T>; // Changed from keyof T to Path<T>
  label: React.ReactNode;
  control: Control<T>;
  rules?: RegisterOptions<T, Path<T>>; // Corrected typing for rules
  sx?: SxProps<Theme>;
  disabled?: boolean;
}

const FormCheckBox = <T extends FieldValues>({ id, name, label, control, rules, sx, disabled = false }: FormCheckBoxProps<T>) => {
  return (
   <Controller
  name={name}
  control={control}
  rules={rules}
  defaultValue={true as any}
  render={({ field: { onChange, value, ref }, fieldState: { error } }) => (
    <FormControlLabel
      control={
        <Checkbox
          id={id}
          checkedIcon={<CheckBoxOutlinedIcon />}
          checked={value ?? true}
          onChange={(e) => onChange(e.target.checked)}
          inputRef={ref}
          sx={{
            mx: 1,
            color: "rgb(83 79 161 / var(--tw-bg-opacity))",

            "&.Mui-checked": {
              color: "rgb(83 79 161 / var(--tw-bg-opacity))",
            },

            ...(error ? { color: "error.main" } : {}),
          }}
        />
      }
      label={
        <>
          {label}
          {error && (
            <Typography
              variant="caption"
              color="error"
              sx={{ display: "block" }}
            >
              {error.message}
            </Typography>
          )}
        </>
      }
      disabled={disabled}
      sx={{ ...sx }}
    />
  )}
/>
  );
};

export default FormCheckBox;
